var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 204.93 111.29",
    style: {
      enableBackground: "new 0 0 204.93 111.29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,34.63V0h9.4v14h0.47L21.9,0h10.96l-11.7,15.42l11.97,19.21H21.9l-7.78-12.99l-3.11,4.06v8.93H1.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.63,34.63V0h24.96v7.58H45.03v5.95H59.3v7.58H45.03v5.95h15.49v7.58H35.63z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.25,34.63V0h24.96v7.58H74.65v5.95h14.27v7.58H74.65v5.95h15.49v7.58H65.25z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.88,34.63V0h14.95c2.57,0,4.82,0.51,6.75,1.52c1.93,1.01,3.43,2.44,4.5,4.28c1.07,1.84,1.61,3.99,1.61,6.44 c0,2.48-0.55,4.63-1.65,6.44c-1.1,1.82-2.64,3.21-4.62,4.19c-1.98,0.98-4.29,1.47-6.93,1.47h-8.93v-7.3h7.04 c1.1,0,2.05-0.19,2.83-0.58c0.78-0.39,1.39-0.94,1.81-1.67c0.42-0.72,0.63-1.57,0.63-2.55c0-0.99-0.21-1.84-0.63-2.54 c-0.42-0.7-1.03-1.25-1.81-1.62c-0.78-0.38-1.73-0.57-2.83-0.57h-3.32v27.12H94.88z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.6,0h11.7l8.05,19.62h0.41L163.8,0h11.7v34.63h-9.2V14.61h-0.27l-7.71,19.75h-5.55l-7.71-19.89h-0.27v20.16 h-9.2V0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.97,34.63V0h24.96v7.58h-15.56v5.95h14.27v7.58h-14.27v5.95h15.49v7.58H179.97z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.78,41.12h18.83v44.43c0,5.28-1.26,9.85-3.78,13.7c-2.52,3.85-6.02,6.82-10.52,8.91 c-4.49,2.09-9.71,3.13-15.65,3.13c-5.98,0-11.22-1.04-15.71-3.13c-4.49-2.09-7.99-5.06-10.48-8.91s-3.74-8.42-3.74-13.7V41.12h18.83 v42.81c0,2.15,0.47,4.06,1.42,5.74c0.95,1.68,2.26,3,3.95,3.95c1.68,0.95,3.59,1.42,5.74,1.42c2.17,0,4.09-0.47,5.76-1.42 c1.67-0.95,2.98-2.26,3.93-3.95c0.95-1.68,1.42-3.59,1.42-5.74V41.12z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.65,56.29V41.12h60.28v15.17h-20.86v54.19h-18.56V56.29H144.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 74.8936,
    x2: 71.2523,
    y2: 74.8936
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47B9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#267DF3"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.63,40.17C15.95,40.17,0,56.12,0,75.8c0,15.57,10.01,28.78,23.93,33.62l3.79-19.98 c-4.7-2.74-7.87-7.82-7.87-13.64c0-8.7,7.08-15.78,15.78-15.78c8.7,0,15.78,7.08,15.78,15.78c0,6.04-3.41,11.29-8.4,13.94 l3.77,19.88c14.21-4.68,24.48-18.04,24.48-33.82C71.25,56.12,55.3,40.17,35.63,40.17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.706e5beb47f239db9d4e9f10e3f28179.svg";
export { ForwardRef as ReactComponent };